import * as React from 'react';
import PaymentDetail from 'src/DetailComponents/PaymentDetail';
import {TransferDetail} from 'src/DetailComponents/TransferDetail';
import type {
  DetailTransactionFragment,
} from '@transactions/graphql';

type Props = {
  onReset?: () => void;
  highlightLineId?: string | null;
  transaction: DetailTransactionFragment;
};

const TransactionDetail = (props: Props) => {
  const {transaction} = props;
  // Determine if payment or transfer based on netAmount
  const isPayment = transaction.netAmount !== 0;

  // Key by transaction id so form state resets when navigating between
  // transactions (the route change reuses the same component instance)
  if (isPayment) {
    return (
      <PaymentDetail
        key={transaction._id}
        payment={transaction}
        onReset={props.onReset}
        highlightLineId={props.highlightLineId}
      />
    );
  } else {
    return (
      <TransferDetail
        key={transaction._id}
        transfer={transaction}
        onReset={props.onReset}
        highlightLineId={props.highlightLineId}
      />
    );
  }
};

export default TransactionDetail;
